import { Component, OnInit,  ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ProcessLoadingService } from '../../services/loading.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'careposi-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {

  isLoading = false;
  progress = 0;
  isShowProgress = false;
  constructor(private pageLoadingService: ProcessLoadingService,
              private cdr: ChangeDetectorRef) {
    this.checkPageLoadingHandler();
  }

  ngOnInit(): void {

  }

  checkPageLoadingHandler(): void {
    this.pageLoadingService.isLoadingEvent
        .subscribe(
          (isLoading: boolean) => {
            if (this.isLoading !== isLoading) {
              this.isLoading = isLoading;
              this.cdr.detectChanges();
            }
          }, (error: any) => {
          }
        );
    this.pageLoadingService.onChangeProcess.subscribe((pro:number) => {
      if (pro > 0) {
        this.isShowProgress = true;
        this.progress = pro;
      }
      else{
        this.progress = 0;
        this.isShowProgress = false;
      }
      this.cdr.detectChanges();
    })
  }
}
